import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import SEO, { getBreadcrumbSchema } from '../components/SEO';
import { Briefcase, Package, Hammer, MapPin } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const HUBS = {
  'praca-budowlana': {
    icon: Briefcase,
    bg: 'from-violet-600 to-purple-700',
    h1: 'Praca budowlana w Polsce — wybierz miasto',
    title: 'Praca budowlana - oferty pracy według miast',
    desc: 'Oferty pracy w budownictwie w 37 największych miastach Polski. Murarz, elektryk, hydraulik, dekarz, operator maszyn - aplikuj bezpłatnie.',
    lead: 'Wybierz miasto, w którym szukasz pracy. W każdym z nich pokazujemy aktualne ogłoszenia firm budowlanych z miasta i okolicy (do 70 km).',
  },
  remonty: {
    icon: Hammer,
    bg: 'from-orange-500 to-amber-600',
    h1: 'Remonty i zlecenia budowlane — wybierz miasto',
    title: 'Remonty według miast - zlecenia i wykonawcy',
    desc: 'Zlecenia remontowe i budowlane w 37 miastach Polski. Dodaj zlecenie bezpłatnie i porównaj oferty sprawdzonych firm z Twojej okolicy.',
    lead: 'Wybierz miasto, w którym potrzebujesz wykonawcy. Zobaczysz aktualne zlecenia i firmy działające w okolicy.',
  },
  'materialy-budowlane': {
    icon: Package,
    bg: 'from-emerald-600 to-teal-700',
    h1: 'Materiały budowlane — wybierz miasto',
    title: 'Materiały budowlane według miast - giełda materiałów',
    desc: 'Kup i sprzedaj materiały budowlane w 37 miastach Polski. Cement, cegły, drewno, izolacje, narzędzia - nowe i używane, bez prowizji.',
    lead: 'Wybierz miasto, w którym szukasz materiałów. Znajdziesz ogłoszenia z miasta i najbliższej okolicy.',
  },
};

const CityHub = ({ vertical }) => {
  const [cities, setCities] = useState([]);
  const hub = HUBS[vertical];
  const Icon = hub.icon;

  useEffect(() => {
    fetch(`${API}/seo/cities`)
      .then((r) => (r.ok ? r.json() : []))
      .then(setCities)
      .catch((e) => console.error('Cities load error:', e));
  }, []);

  const byVoivodeship = cities.reduce((acc, c) => {
    acc[c.voivodeship] = [...(acc[c.voivodeship] || []), c];
    return acc;
  }, {});

  return (
    <div className="min-h-screen bg-slate-50" data-testid="city-hub-page">
      <SEO
        title={hub.title}
        description={hub.desc}
        canonical={`/${vertical}`}
        structuredData={getBreadcrumbSchema([
          { name: 'Strona główna', path: '/' },
          { name: hub.title, path: `/${vertical}` },
        ])}
      />

      <div className={`bg-gradient-to-r ${hub.bg} py-14`}>
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 flex items-start gap-4">
          <div className="w-14 h-14 bg-white/20 rounded-xl flex items-center justify-center shrink-0">
            <Icon className="w-8 h-8 text-white" />
          </div>
          <div>
            <h1 className="font-heading font-bold text-3xl sm:text-4xl text-white">{hub.h1}</h1>
            <p className="text-white/80 mt-2 max-w-2xl">{hub.lead}</p>
          </div>
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-10 space-y-8">
        {Object.entries(byVoivodeship).map(([voivodeship, list]) => (
          <section key={voivodeship}>
            <h2 className="font-heading font-bold text-base md:text-lg text-slate-900 mb-3">woj. {voivodeship}</h2>
            <div className="flex flex-wrap gap-2">
              {list.map((c) => (
                <Link
                  key={c.slug}
                  to={`/${vertical}/${c.slug}`}
                  className="rounded-full bg-white border border-slate-200 px-4 py-2 text-sm text-slate-700 hover:border-slate-400 transition-colors flex items-center gap-1"
                  data-testid={`hub-city-${c.slug}`}
                >
                  <MapPin className="w-3.5 h-3.5 text-slate-400" />{c.name}
                </Link>
              ))}
            </div>
          </section>
        ))}
      </div>
    </div>
  );
};

export default CityHub;
